import { useState } from 'react';
import { MicrositeVideoPlayer } from '~/components/MicrositeVideo';
import MicrositeSection from '~/components/MicrositeSection';
import type { VideoBlockVariant } from '~/editor/blocks/video/common';
import BetaSectionHeader from '~/editor/templates/beta/lib/BetaSectionHeader';
import BetaTabs from '~/editor/templates/beta/lib/BetaTabs';

export default function VideoBlockBeta({ id, title, videos }: VideoBlockVariant) {
	const [active, setActive] = useState(0);

	if (videos.length === 0) {
		return null;
	}

	let header = <></>;

	if (title) {
		header = <BetaSectionHeader align="start" title={title} />;
	}

	if (videos.length > 1) {
		header = <BetaTabs active={active} items={videos} getLabel={(_, index) => `Video ${index + 1}`} onChange={setActive} />;
	}

	return (
		<MicrositeSection id={id} padding>
			{header}
			<MicrositeVideoPlayer video={videos[active]} />
		</MicrositeSection>
	);
}
